export const FORM_MODAL_CONTENT_CONTAINER_BOX_SIZE = 'm'
